import _styled from "@emotion/styled-base";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    transform: translateX(-20%);\n  }\n  25% {\n    transform: translateX(20%);\n  }\n  50% {\n    transform: translateX(-10%);\n  }\n  75% {\n    transform: translateX(10%);\n  }\n  100% {\n    transform: translateX(0);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { css, keyframes } from '@emotion/core';
export var Section = _styled("section", {
  target: "ez8d5co0"
})({
  name: "z73qd5",
  styles: "align-items:center;display:flex;flex-direction:column;font-family:var(--font1);justify-content:center;padding:2em;"
});
export var Flex = _styled("div", {
  target: "ez8d5co1"
})({
  name: "k008qs",
  styles: "display:flex;"
});
export var CodeForm = _styled("form", {
  target: "ez8d5co2"
})({
  name: "vbhcra",
  styles: "align-items:top;display:flex;flex-direction:column;justify-content:center;"
});
export var Form = _styled("form", {
  target: "ez8d5co3"
})({
  name: "1p9qldt",
  styles: "max-width:40em;width:100%;"
});
export var Label = _styled("label", {
  target: "ez8d5co4"
})({
  name: "1e7pvyb",
  styles: "align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start;margin-bottom:0.5em;span,strong{min-width:100px;padding-right:1em;}strong{font-weight:600;}"
});
export var Person = _styled("div", {
  target: "ez8d5co5"
})({
  name: "1xo5moz",
  styles: "margin-bottom:2em;"
});
export var Header = _styled("h2", {
  target: "ez8d5co6"
})({
  name: "18b30du",
  styles: "font-weight:600;margin-top:1.25em;margin:2em 0 0.5em 0;"
});
export var Spacer = _styled("div", {
  target: "ez8d5co7"
})({
  name: "1uo6o3",
  styles: "height:1em;"
});
export var MultiLabel = _styled("div", {
  target: "ez8d5co8"
})({
  name: "1l59d0z",
  styles: "display:flex;flex-wrap:wrap;margin-bottom:0.5em;input[type='radio'],input[type='checkbox']{margin-right:1em;}"
});
export var Input = _styled("input", {
  target: "ez8d5co9"
})({
  name: "6meis4",
  styles: "border:0;border-bottom:2px solid var(--color-variable-1);display:block;font-family:inherit;font-size:1em;margin:0.5em 0;outline:none;padding:0.25em;line-height:normal;&[disabled]{background:#eee;color:#666;}"
});
export var CodeInput = _styled("input", {
  target: "ez8d5co10"
})({
  name: "1ouj8c1",
  styles: "border:1px solid var(--color-variable-1);display:block;font-family:inherit;font-size:1.25em;margin:0.5em 0;outline:none;padding:0 1em;line-height:2;&[disabled]{background:#eee;color:#666;}"
});
export var Textarea = _styled("textarea", {
  target: "ez8d5co11"
})({
  name: "1vcyf9k",
  styles: "border:0;border-bottom:2px solid var(--color-variable-1);box-sizing:border-box;display:block;flex-basis:100%;font-family:inherit;font-size:1em;line-height:1.25;height:calc(1.75em);margin-top:0.25em;outline:none;overflow:hidden;padding:0.25em;resize:none;"
});
export var Submit = _styled("button", {
  target: "ez8d5co12"
})({
  name: "1bxxk1u",
  styles: "border:1px solid var(--color-variable-1);background:var(--color-variable-1);color:var(--color-variable-2);display:inline-block;font-family:inherit;font-size:1.25em;margin:0.5em 0;outline:none;padding:0 1em;position:relative;line-height:2;"
});
var rotation = keyframes(_templateObject());
export var loading = /*#__PURE__*/css("color:transparent;&:before{animation:", rotation, " 1s ease-in-out infinite;border:3px solid;border-color:#fff transparent #fff transparent;border-radius:50%;box-sizing:border-box;content:'';height:1em;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:1em;}");
var doh = keyframes(_templateObject2());
export var Error = _styled("p", {
  target: "ez8d5co13"
})("animation:", doh, " 500ms ease-in-out;color:var(--color-variable-1);text-align:center;");
export var SwitchLabel = _styled("label", {
  target: "ez8d5co14"
})({
  name: "wk2kac",
  styles: "display:flex;letter-spacing:0.125em;margin-bottom:2em;text-transform:uppercase;"
});
export var SwitcherWrap = _styled("div", {
  target: "ez8d5co15"
})({
  name: "1nqk4x3",
  styles: "display:inline-block;height:1.5rem;position:relative;width:40px;input{opacity:0;width:0;height:0;}"
});
export var Switcher = _styled("div", {
  target: "ez8d5co16"
})({
  name: "hransx",
  styles: "background-color:#e0e5e8;border-radius:1em;bottom:0;cursor:pointer;left:0;position:absolute;right:0;top:0;transition:0.4s;&:before{background-color:#8fa1b3;border-radius:50%;bottom:0.25rem;content:'';height:1rem;left:0.25rem;position:absolute;transition:0.4s;width:1rem;}input:checked + &{background-color:var(--color-variable-1);&:before{background-color:#fff;transform:translateX(1rem);}}"
});
export var Radio = _styled("div", {
  target: "ez8d5co17"
})({
  name: "15p83z8",
  styles: "border:2px solid var(--color-variable-1);border-radius:1em;bottom:0;box-sizing:border-box;cursor:pointer;height:1.5em;margin-right:1em;position:relative;width:1.5em;input{opacity:0;width:0;height:0;}div{background-color:var(--color-variable-1);border-radius:50%;content:'';height:0;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);transition:200ms ease-in-out;width:0;}input:checked + div{height:1em;width:1em;}"
});